module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ko":{"no_item_message":{"none":"상품이 없습니다.","filtered":"조건에 맞는 상품이 없습니다."}}}')
  delete Component.options._Ctor
}
